import {
  AppBar,
  Alert,
  Box,
  Button,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  Stack,
  SvgIcon,
  Toolbar,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as Logo } from "assets/images/Logo.svg";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddIcon from "@mui/icons-material/Add";
import { Outlet, Link as RouterLink, useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import NewContent from "components/NewContent";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { signOut } from "services/user";

const StackSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3"
    />
  </svg>
);

const MainLayout = () => {
  const { pathname } = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleNewContentClick = () => {
    setDrawerOpen(true);
  };

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBar position="static" sx={{ bgcolor: "grey.600" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Logo />
          <Alert severity="error" variant="filled">
          Our dubs work best for single speakers right now.
          </Alert>
          <Stack direction="row">
            <Tooltip title="Logout">
              <IconButton onClick={handleLogout} color="secondary">
                <LogoutIcon />
              </IconButton>
            </Tooltip>
            <Button
              variant="contained"
              onClick={handleNewContentClick}
              color="secondary"
            >
              <AddIcon sx={{ mr: 1 }} />
              <Typography sx={{ fontWeight: 700 }}>New Content</Typography>
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <CloseIcon
          onClick={() => setDrawerOpen(false)}
          sx={{
            position: "absolute",
            top: 36,
            right: 30,
            cursor: "pointer",
            color: "grey.100",
          }}
        />
        <NewContent setDrawerOpen={setDrawerOpen} />
      </Drawer>
      <Stack
        direction="row"
        sx={{
          height: "100%",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            zIndex: 1,
            boxShadow:
              "0px 0px 18px rgba(0, 0, 0, 0.16), 0px 0px 28px rgba(0, 0, 0, 0.16), 0px 0px 52px rgba(0, 0, 0, 0.16)",
          }}
        >
          <List>
            {[
              {
                link: "/",
                icon: <DashboardIcon />,
              },
              {
                link: "/content",
                icon: (
                  <SvgIcon>
                    <StackSvg />
                  </SvgIcon>
                ),
              },
              // TODO add scheduler page
              {
                link: "/settings",
                icon: <SettingsIcon />,
              },
              // {
              //   link: "/storage",
              //   icon: (
              //     <SvgIcon>
              //       <StackSvg />
              //     </SvgIcon>
              //   ),
              // },
            ].map(({ link, icon }) => {
              const isCurrentPath = "/" + pathname.split("/")[1] === link;
              return (
                <ListItemButton
                  key={link}
                  component={RouterLink}
                  to={link}
                  sx={{ position: "relative" }}
                >
                  <ListItemIcon
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      color: isCurrentPath ? "info.main" : null,
                    }}
                  >
                    {icon}
                  </ListItemIcon>
                  {isCurrentPath && (
                    // transition with https://chat.openai.com/share/84bae99c-0e86-4daf-882e-c272d31dbd0d
                    <Box
                      sx={{
                        height: "100%",
                        width: 8,
                        position: "absolute",
                        right: 0,
                        backgroundColor: "info.main",
                        borderRadius: "6px 0px 0px 6px",
                      }}
                    />
                  )}
                </ListItemButton>
              );
            })}
          </List>
        </Box>
        <Outlet />
      </Stack>
    </Box>
  );
};
export default MainLayout;
